// extracted by mini-css-extract-plugin
export default {"box":"eatInformation_box__3M++t"};